import React from "react";
import { Table } from "react-bootstrap";
import MainModal from "../../Main/Modal/MainModal";
import styles from "../CurrencyInfo.module.scss";

const CurrencyTable = ({ currency }) => {
  return (
    <div>
      <Table striped bordered hover size="sm" className={styles.table}>
        <thead>
          <tr>
            <th colSpan="2" className={styles.tableHeading}>
              {currency.name}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Rank</td>
            <td>{currency.rank}</td>
          </tr>
          <tr>
            <td>Symbol</td>
            <td>{currency.symbol}</td>
          </tr>
          <tr>
            <td>Name</td>
            <td>{currency.name}</td>
          </tr>
          <tr>
            <td>Supply</td>
            <td>{+Number(currency.supply).toFixed(2)}</td>
          </tr>
          <tr>
            <td>Max Supply</td>
            <td>{+Number(currency.maxSupply).toFixed(2)}</td>
          </tr>
          <tr>
            <td>Market Cap</td>
            <td>{+Number(currency.marketCapUsd).toFixed(2)}$</td>
          </tr>
          <tr>
            <td>Price</td>
            <td>{+Number(currency.priceUsd).toFixed(2)}$</td>
          </tr>
          <tr>
            <td>Change per 24hr</td>
            <td>{+Number(currency.changePercent24Hr).toFixed(2)}%</td>
          </tr>
          <tr>
            <td colSpan="2">
              <MainModal currency={currency} />
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};
export default CurrencyTable;
